import styled, { createGlobalStyle } from 'styled-components'
import 'react-spring-bottom-sheet/dist/style.css'
import { BottomSheet } from 'react-spring-bottom-sheet'

interface HeaderProps {
  showBorder: boolean
}

interface ContentContainerProps {
  minHeight?: string
}

export const GlobalStyle = createGlobalStyle`
  .crisp-client {
    display: none !important;
  }
  reach-portal { position: relative; z-index: 1001; }
`

export const StyledBottomSheet = styled(BottomSheet)`
  --rsbs-backdrop-bg: rgba(0, 0, 0, 0.6);
  --rsbs-bg: #ffffff;
  --rsbs-handle-bg: #d1d5db;
  --rsbs-max-w: 100%;
  --rsbs-ml: 0;
  --rsbs-mr: 0;
  --rsbs-overlay-rounded: 16px;

  [data-rsbs-handle] {
    background-color: var(--rsbs-handle-bg);
    width: 48px;
    height: 4px;
    border-radius: 2px;
    margin: 12px auto;
  }

  [data-rsbs-content] {
    padding: 0;
    background: var(--rsbs-bg);
    border-radius: var(--rsbs-overlay-rounded) var(--rsbs-overlay-rounded) 0 0;
  }

  [data-rsbs-backdrop] {
    background-color: var(--rsbs-backdrop-bg);
  }
`

export const ContentContainer = styled.div<ContentContainerProps>`
  padding: 20px;
  min-height: ${(props) => props.minHeight || '200px'};
  max-height: 80vh;
  overflow-y: auto;
`

export const Header = styled.div<HeaderProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 0;
  border-bottom: ${(props) => (props.showBorder ? '1px solid #e5e7eb' : 'none')};
  margin-bottom: ${(props) => (props.showBorder ? '20px' : '0')};
`

export const Title = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
`

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  color: #6b7280;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f3f4f6;
    color: #374151;
  }

  &:focus {
    outline: 2px solid #3b82f6;
    outline-offset: 2px;
  }
`
